export default __webpack_public_path__ + "static/media/avatar_tommy10.227f2a33.mp3";